<script>
    import {catalogStore} from "../../common/store/catalog-store";

    export default {
        name: "CatalogSort",

        data() {
            return {
                storeState: catalogStore.state,
                sortOptions: [
                    {label: 'Padrão', value: null},
                    {label: 'Menor preço', value: 'menor-preco'},
                    {label: 'Maior preço', value: 'maior-preco'},
                    {label: 'Lançamentos', value: 'lancamentos'},
                ],
            }
        },

        computed: {
            selected() {
                return this.storeState.selected;
            },

            selectedSort() {
                return this.sortOptions.find(o => this.selected.sort === o.value);
            }
        },

        methods: {
            sort(value) {
                let url = new URL(window.location.href);

                // Reseta página
                url.searchParams.delete('page');

                if (value) url.searchParams.set('sort', value);
                else url.searchParams.delete('sort');

                catalogStore.fetch(this.axios, url.toString());
            },
        }
    }
</script>